import { Component, Input, Output, EventEmitter } from '@angular/core';
import { LanguageChangeService } from 'src/services/language-change/language-change.service';
import { TranslateService } from '@ngx-translate/core';
import { LoggerService } from 'src/services/logger-services/logger.service';
@Component({
  selector: 'app-feedback-section',
  templateUrl: './feedback-section.component.html',
  styleUrls: []
})
export class FeedbackSectionComponent {
  @Input() chatdata: any;
  @Input() configdata: any;

  @Output() onClear: EventEmitter<any> = new EventEmitter();
  @Output() onSubmit: EventEmitter<any> = new EventEmitter();


  constructor(
    private readonly languageService: LanguageChangeService,
    private readonly translate: TranslateService,
    private readonly loggerService: LoggerService
  ){}

  /** Error template for FEEDBACK SECTION */
  private readonly feedbackSectionError = (error: any) =>
    `[FEEDBACK SECTION] - ${JSON.stringify(error)}`;

  isAnyOptionChecked(options: any[]): boolean {
    return options.some(opt => opt.IsChecked);
  }

  handleClear() {
    this.onClear.emit(this.chatdata);
  }

  handleSubmit() {
    try {
      const isValid = this.isAnyOptionChecked(this.chatdata.FeedbackOptions);
      this.chatdata.ErrorMsg = !isValid;
      if (!isValid) return;
      this.onSubmit.emit(this.chatdata);
    } catch (error) {
      this.loggerService.logError(this.feedbackSectionError(error), "handleSubmit");
    }
  }
}
